// extracted by mini-css-extract-plugin
export var actionButton = "_fg-0";
export var attachmentLine = "_fg-1";
export var fileInput = "_fg-2";
export var fileUploadWrapper = "_fg-4";
export var footer = "_fg-3";
export var modalContent = "_fg-5";
export var paperclip = "_fg-6";
export var quillEditor = "_fg-7";